/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Bodymap_Nature_LabelInputs */

const en_us2_bodymap_nature_label = /** @type {(inputs: Bodymap_Nature_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What does it feel like?`)
};

const pt_br2_bodymap_nature_label = /** @type {(inputs: Bodymap_Nature_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Como é essa dor?`)
};

const es_419_bodymap_nature_label = /** @type {(inputs: Bodymap_Nature_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Cómo es ese dolor?`)
};

const pt_pt2_bodymap_nature_label = /** @type {(inputs: Bodymap_Nature_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Como é essa dor?`)
};

const fr_fr2_bodymap_nature_label = /** @type {(inputs: Bodymap_Nature_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ça ressemble à quoi ?`)
};

const de_de2_bodymap_nature_label = /** @type {(inputs: Bodymap_Nature_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wie fühlt es sich an?`)
};

const it_it2_bodymap_nature_label = /** @type {(inputs: Bodymap_Nature_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Che tipo di dolore è?`)
};

/**
* | output |
* | --- |
* | "What does it feel like?" |
*
* @param {Bodymap_Nature_LabelInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const bodymap_nature_label = /** @type {((inputs?: Bodymap_Nature_LabelInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Bodymap_Nature_LabelInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_bodymap_nature_label(inputs)
	if (locale === "es-419") return es_419_bodymap_nature_label(inputs)
	if (locale === "pt-PT") return pt_pt2_bodymap_nature_label(inputs)
	if (locale === "fr-FR") return fr_fr2_bodymap_nature_label(inputs)
	if (locale === "de-DE") return de_de2_bodymap_nature_label(inputs)
	if (locale === "it-IT") return it_it2_bodymap_nature_label(inputs)
	return en_us2_bodymap_nature_label(inputs)
});
export { bodymap_nature_label as "bodymap.nature.label" }